import { Component, Vue, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { competencyAPI } from '@/providers/apis/competency/competency';
import { sortByProperty } from '@/utils/utils';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import GdotPreview from '@/components/cards/Gdot-preview/gdot-preview';
import moment from 'moment';
import GdotMappingPopup from '@/components/cards/gdot-add-mapping/gdot-add-mapping-popup';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'competency-gdot',
    components: {
      'material-icon': GoogleMaterialIcon,
      'gdot-preview': GdotPreview,
      'gdot-mapping-popup': GdotMappingPopup,
    },
})
export default class CompetencyGdot extends Vue {

      public universalViewMode = false;

      public offset = 0;

      public limit = 10;

      public currentPage = 1;

      public totalItems: number = 0;

      public isLoading = false;

    // -----------------------------------------------------------------------
    // Properties

    private fields: any = [
        {
          key: 'created_at',
          label: 'Date',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'target_subject_name',
          label: 'Subject to Crosswalk',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'subject-name',
        },
        {
          key: 'universal_subject_name',
          label: 'Universal Subject',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'mapped',
          label: 'Mapped',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'notMapped',
          label: 'Not Mapped',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ];

      private mappingDetails: any = [];

      private isPreview: boolean = false;

      private previewItem: any;

      private originalMappingDetails: any;

      private isAddNew = false;

      private searchTerms = '';

    // ------------------------------------------------------------------------
    // Actions
    public addNew() {
      this.isAddNew = true;
    }
    public getGDotDetail(content: any = null) {
      this.isLoading = true;
      let params;
      if (content) {
        params = content;
      } else {
        params = {
          offset: this.offset,
          limit: this.limit,
        };
      }
      competencyAPI.getGdotList(params).then((data) => {
        this.isLoading = false;
        data.ucmlist.map((item: any) => {
          item.created_at = moment(item.created_at).format('DD MMM YYYY');
        });
        this.mappingDetails = data.ucmlist;
        this.originalMappingDetails = data.ucmlist;
        this.totalItems = data.totalCount;
      });
    }
    public loadContent(page: number) {
      this.currentPage = page;
      this.offset = (page - 1) * this.limit;
      this.getGDotDetail();
    }

    // ------------------------------------------------------------------------
    // Hooks

    private created() {
      const session: any = sessionService.getSession();
      this.universalViewMode = session.permissions.indexOf('UNIVERSAL_CROSSWALK_VIEW') !== -1;
      this.getGDotDetail();
    }

    private onSearchUcmList(searchTerms: string) {
      if (searchTerms === '') {
        this.getGDotDetail();
      } else {
         this.searchTerms = searchTerms;
         const params = {
           search: this.searchTerms,
         };
         this.getGDotDetail(params);
      }
    }
    private hideMappingModal(value: any) {
      this.isAddNew = false;
      if (value) {
        this.getGDotDetail();
      }
    }
    private prviewSubject(item: any) {
      this.isPreview = true;
      this.previewItem = item;
    }
    private closePreview(item: any) {
      this.isPreview = false;
      this.previewItem = null;
      this.getGDotDetail();
    }
    private onRefresh() {
      this.getGDotDetail();
    }
}
